import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-caex-confirmation',
  templateUrl: './caex-confirmation.component.html',
  styleUrls: ['./caex-confirmation.component.scss']
})
export class CaexConfirmationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
